import { observer } from 'mobx-react-lite';

import { DetailCard } from 'components/details/DetailCard';
import { DetailList } from 'components/details/DetailList';
import { EditString } from 'components/forms/EditString';
import { EditEventPathReference } from 'edit/reference/EditEventPathReference';

import type { EditableNodeDefinition } from '../../edit/EditableNodeDefinition';
import type { EditableRaiseEvent } from '../../edit/EditableRaiseEvent';

// Its own observer so a field edit re-renders just this card (and the collapsed subtitle), not the whole list.
const RaiseEventCard = observer(({ event }: { readonly event: EditableRaiseEvent }) => (
  <DetailCard title="Raise Event" subtitle={event.summary} collapsible onRemove={event.delete} removeLabel="Remove raise event">
    <div className="d-flex flex-column gap-2">
      <EditEventPathReference label="Event" value={event.path} onChange={(v) => (event.path = v)} />
      <EditString label="Raiser Comment (or =expression)" value={event.raiserComment} onChange={(v) => (event.raiserComment = v)} />
      <EditString label="Precondition (true or =expression)" value={event.precondition} onChange={(v) => (event.precondition = v)} />
    </div>
  </DetailCard>
));

/**
 * The Raise Events tab: the definition's raise-event links, a native MobX view over its Aggregate (add / remove / edit).
 * Cards aren't reorderable — order isn't meaningful for events.
 */
export const RaiseEventsTab = observer(({ entity }: { readonly entity: EditableNodeDefinition }) => (
  <DetailList
    items={entity.raiseEvents}
    getKey={(event) => event.key}
    onAdd={entity.createRaiseEvent}
    addLabel="Add raise event"
    renderItem={(event) => <RaiseEventCard event={event} />}
  />
));
